var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: {
        "content-class": "v-application v-application--is-ltr",
        "max-width": "580px",
        fullscreen: !_vm.$vuetify.breakpoint.mdAndUp,
      },
      model: {
        value: _vm.isOpen,
        callback: function ($$v) {
          _vm.isOpen = $$v
        },
        expression: "isOpen",
      },
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title"),
          _vm._v(" "),
          _c(
            "v-card-text",
            [
              _c(
                "v-alert",
                {
                  attrs: {
                    prominent: "",
                    dense: "",
                    outlined: "",
                    color: "error",
                    icon: "mdi-alert-circle",
                  },
                },
                [_vm._v("\n                Freiberufler Storno\n            ")]
              ),
              _vm._v(" "),
              _c(
                "v-row",
                { staticClass: "pl-3" },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "auto" } },
                    [
                      _c("v-checkbox", {
                        attrs: {
                          label: "Termine freigeben",
                          "hide-details": "",
                        },
                        model: {
                          value: _vm.remove_ma_from_appointment,
                          callback: function ($$v) {
                            _vm.remove_ma_from_appointment = $$v
                          },
                          expression: "remove_ma_from_appointment",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-row",
                { staticClass: "pl-3" },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "auto" } },
                    [
                      _c("v-checkbox", {
                        attrs: {
                          label: "Storno mail senden?",
                          "hide-details": "",
                        },
                        model: {
                          value: _vm.send_mail,
                          callback: function ($$v) {
                            _vm.send_mail = $$v
                          },
                          expression: "send_mail",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.send_mail
                ? _c(
                    "v-row",
                    { staticClass: "pl-3" },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "auto" } },
                        [
                          _c("v-checkbox", {
                            staticClass: "mt-0",
                            attrs: {
                              label:
                                "Storno vom Freiberufler (wird in der Statistik des Fbs hinterlegt)",
                              "hide-details": "",
                            },
                            model: {
                              value: _vm.is_cancelled_by_pharmacist,
                              callback: function ($$v) {
                                _vm.is_cancelled_by_pharmacist = $$v
                              },
                              expression: "is_cancelled_by_pharmacist",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-actions",
            { staticClass: "justify-end" },
            [
              _c(
                "v-btn",
                {
                  attrs: { outlined: "", color: "secondary" },
                  on: {
                    click: function ($event) {
                      _vm.isOpen = false
                    },
                  },
                },
                [_vm._v("\n                Abbrechen\n            ")]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "confirm-delete-btn",
                  attrs: { color: "error", depressed: "" },
                  on: { click: _vm.onConfirm },
                },
                [_vm._v("\n                Entfernen\n            ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }